export enum HistoryOrderType {
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  CRYPTO_DEPOSIT = 'CRYPTO_DEPOSIT',
  CRYPTO_WITHDRAWAL = 'CRYPTO_WITHDRAWAL',
  EXCHANGE = 'EXCHANGE_MONEY',
}